<div class="form-control" style="width: 100%">
  <mat-label [ngClass]="header ? headerClass : 'header-new'">{{ header ? header :  label }}</mat-label
  >
  <span *ngIf="!withoutBr">
    <br />
  </span>
  <mat-radio-group
  [formControl]="controlName"
  [ngClass]="alignment == 'vertical' ? 'vertical-radio-group' : '' "
  >
  <ng-content></ng-content>
  <span *ngIf="!withoutBr">
    <br/>
  </span>
    <mat-radio-button
      [ngClass]="alignment == 'vertical' ? 'vertical-radio-button' : '' "
      color="primary"
      *ngFor="let elm of options"
      [value]="elm.value"
      [disabled]="isDisable"
      [checked]="elm?.checked"
    >
      {{elm.label}}
    </mat-radio-button>
  </mat-radio-group>
  <br/>
  <mat-error *ngIf="hasError()">{{ getErrorMessage() }}</mat-error>
</div>
